<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body='false' @close="$emit('closeView')">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('xiang-qing-xin-xi')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang-bian-hao-0')" :label-width="formLabelWidth" prop="operatorId">
                  <label v-text="detailForm.operatorId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang-ming-cheng-0')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('xiang-bian-ming-cheng-0')" :label-width="formLabelWidth" prop="name">
                  <label v-text="detailForm.name"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('xiang-bian-gong-shuai-kw')" :label-width="formLabelWidth" prop="powerLoad">
                  <label v-text="detailForm.powerLoad"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chang-zhan-bian-hao-0')" :label-width="formLabelWidth" prop="stationCode">
                  <label v-text="detailForm.stationCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chang-zhan-ming-cheng-0')" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qiang-kou-bian-hao-lie-biao')" :label-width="formLabelWidth" prop="gunCode">
                  <label v-text="detailForm.gunCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chuang-jian-ren-0')" :label-width="formLabelWidth" prop="createName">
                  <label v-text="detailForm.createName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chuang-jian-shi-jian-0')" :label-width="formLabelWidth" prop="creationTime">
                  <label v-text="detailForm.createTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation', 'bindingInformation', 'dateInformation'],
        formLabelWidth: '150px',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: this.$t('qing-xuan-ze-fei-shuai'), trigger: 'blur'}]
        },
      }
    },
    props:{
      viewVisible:{
        type:Boolean,
        required: true
      },
      detailForm: {},
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      serviceBillingRulesIdTemp: ''
    },
    methods:{
      unbinding(){
        console.log('点击了解绑！')
        this.$emit("unbinding")
      },
      dobinding(){
        console.log('点击了绑定！')
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/customizeView.vue